module.exports = __webpack_public_path__ + "img/馬達控制器1.923f4404.jpg";